var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('talmundo-input',{attrs:{"twolines":true,"type":"input","id":"QuestionPlaceholder","label":_vm.$t('form.placeholder'),"value":_vm.value},on:{"changeValue":function($event){return _vm.changeType($event, 'placeholder')},"updateValue":function($event){return _vm.updateValue($event, 'placeholder')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }